<div [formGroup]="group">
  <!-- Payment Method -->
  <beautyapp-select
    formControlName="paymentMethod"
    [label]="'servicePackages.sellModal.paymentMethod' | translate"
    [data]="paymentMethods"
    displayMember="label"
    valueMember="value"
  ></beautyapp-select>

  <!-- CASH: display-only amount (backend auto-fills from package price).
       Native input used instead of <beautyapp-input> because the shared
       component does not expose settable [value] / [disabled] inputs. -->
  @if (selectedMethod === 'CASH') {
    <label for="package-amount-cash" class="text-xs text-gray-500 block mb-1">{{ 'PAYMENTTYPE.1' | translate }}</label>
    <div class="relative">
      <span class="absolute left-2 top-1/2 -translate-y-1/2">₾</span>
      <input
        id="package-amount-cash"
        type="float"
        class="w-full border rounded px-6 py-2 bg-gray-100 cursor-not-allowed"
        [value]="amount"
        disabled
      />
    </div>
  }

  <!-- CARD: card + bank select -->
  @if (selectedMethod === 'CARD') {
    <div class="flex gap-3">
      <beautyapp-input
        formControlName="card"
        [label]="'PAYMENTTYPE.2' | translate"
        type="float"
        prefix="₾"
      ></beautyapp-input>
      <beautyapp-select
        formControlName="bank"
        [label]="'calendar.form.paymentMethod' | translate"
        [data]="banks"
        displayMember="name"
        valueMember="id"
      ></beautyapp-select>
    </div>
  }

  <!-- MIXED: cash + card + bank + balance + bankTransfer + bankTransferBank -->
  @if (selectedMethod === 'MIXED') {
    <beautyapp-input
      formControlName="cash"
      [label]="'PAYMENTTYPE.1' | translate"
      type="float"
      prefix="₾"
    ></beautyapp-input>
    <div class="flex gap-3">
      <beautyapp-input
        formControlName="card"
        [label]="'PAYMENTTYPE.2' | translate"
        type="float"
        prefix="₾"
      ></beautyapp-input>
      <beautyapp-select
        formControlName="bank"
        [label]="'calendar.form.paymentMethod' | translate"
        [data]="banks"
        displayMember="name"
        valueMember="id"
      ></beautyapp-select>
    </div>
    <beautyapp-input
      formControlName="balance"
      [label]="'PAYMENTTYPE.5' | translate"
      type="float"
      prefix="₾"
    ></beautyapp-input>
    <div class="flex gap-3">
      <beautyapp-input
        formControlName="bankTransfer"
        [label]="'PAYMENTTYPE.8' | translate"
        type="float"
        prefix="₾"
      ></beautyapp-input>
      <beautyapp-select
        formControlName="bankTransferBank"
        [label]="'calendar.form.paymentMethod' | translate"
        [data]="banks"
        displayMember="name"
        valueMember="id"
      ></beautyapp-select>
    </div>
  }

  <!-- BALANCE: display-only amount (backend auto-fills from package price).
       Native input used instead of <beautyapp-input> because the shared
       component does not expose settable [value] / [disabled] inputs. -->
  @if (selectedMethod === 'BALANCE') {
    <label for="package-amount-balance" class="text-xs text-gray-500 block mb-1">{{ 'PAYMENTTYPE.5' | translate }}</label>
    <div class="relative">
      <span class="absolute left-2 top-1/2 -translate-y-1/2">₾</span>
      <input
        id="package-amount-balance"
        type="float"
        class="w-full border rounded px-6 py-2 bg-gray-100 cursor-not-allowed"
        [value]="amount"
        disabled
      />
    </div>
  }

  <!-- BARTER: no extra fields -->

  <!-- CONSIGNATION: cash + card + bank + consignation -->
  @if (selectedMethod === 'CONSIGNATION') {
    <beautyapp-input
      formControlName="cash"
      [label]="'PAYMENTTYPE.1' | translate"
      type="float"
      prefix="₾"
    ></beautyapp-input>
    <div class="flex gap-3">
      <beautyapp-input
        formControlName="card"
        [label]="'PAYMENTTYPE.2' | translate"
        type="float"
        prefix="₾"
      ></beautyapp-input>
      <beautyapp-select
        formControlName="bank"
        [label]="'calendar.form.paymentMethod' | translate"
        [data]="banks"
        displayMember="name"
        valueMember="id"
      ></beautyapp-select>
    </div>
    <beautyapp-input
      formControlName="consignation"
      [label]="'PAYMENTTYPE.7' | translate"
      type="float"
      prefix="₾"
    ></beautyapp-input>
  }

  <!-- BANK_TRANSFER: bankTransfer + bankTransferBank -->
  @if (selectedMethod === 'BANK_TRANSFER') {
    <div class="flex gap-3">
      <beautyapp-input
        formControlName="bankTransfer"
        [label]="'PAYMENTTYPE.8' | translate"
        type="float"
        prefix="₾"
      ></beautyapp-input>
      <beautyapp-select
        formControlName="bankTransferBank"
        [label]="'calendar.form.paymentMethod' | translate"
        [data]="banks"
        displayMember="name"
        valueMember="id"
      ></beautyapp-select>
    </div>
  }
</div>
